/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {TSO}                     from '@/models/scenario/t.s.o';
import {TSOChange}               from '@/screens/ide/tso/t.s.o.change';
import {TSOEditorComponent}      from '@/components/t.s.o.editor.component';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class DeleteTSOCommand
 *
 * @brief reversible deletion of a tso
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class DeleteTSOCommand implements ICommand {

  private oldValue: TSOChange          = null;
  private   editor: TSOEditorComponent = null;
  private   oldTSO: TSO                = null;

    constructor(oldValue: TSOChange, editor: TSOEditorComponent) {

    this.oldValue = oldValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* find the block of the current selection */

    const    input: TSOChange = this.oldValue.snapshot;

    this.oldTSO = Array.from(this.editor.scenario.tso().values()).
      find(x => x._id === this.oldValue.id);

    Logger.debug('[tso/table:del] deleting ', this.oldTSO);

    /* remove it from the scenario */

    this.editor.scenario.tso().delete(this.oldTSO._id);

    /* refresh the views */

    this.editor.table.refreshTable();

    Logger.debug('[tso/table:del] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[tso/table:del] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /*
     * add the tso back to the scenario, we can just re-insert, because scenario doesn't
     *  ever reuse TSO IDs
     *
     */

    Logger.debug('[tso/table:del] adding back ', this.oldTSO);

    this.editor.scenario.tso().set(this.oldTSO._id, this.oldTSO);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();

    Logger.debug('[tso/table:del] refreshed.');

    /*
     * (re)select what was selected when we deleted, this brings back the
     * selection, and the the edit inputs as they were just before the
     * deletion.
     *
     */

    this.editor.table.doSelection(this.oldValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.oldValue instanceof TSOChange) ? this.oldValue.id : '';

    return '[tso/table:del] ' + b;
  }

}
